<iframe *ngIf="reportUrl" [src]="reportUrl" id="reportpreview" class="w-100 h-100" frameBorder="0" (load)="onReportLoaded()"></iframe>